import PropTypes from 'prop-types';

const productPropType = PropTypes.shape({
	code: PropTypes.string,
	name: PropTypes.string,
	description: PropTypes.string,
});

export default {
	id: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	number: PropTypes.string.isRequired,
	accountNumber: PropTypes.string,
	sortCode: PropTypes.string.isRequired,
	product: productPropType,
	actionsAvailable: PropTypes.object,
	bank_id: PropTypes.string.isRequired,
	metadata: PropTypes.shape({
		account_name: PropTypes.string,
		display_order: PropTypes.number.isRequired,
	}).isRequired,
	displayName: PropTypes.string.isRequired,
	balances: PropTypes.arrayOf(productPropType).isRequired,
	code: PropTypes.string,
	showIcon: PropTypes.bool,
	display_order: PropTypes.number.isRequired,
};
